import { SxProps } from '@mui/material';

import { Content } from './IntegrationsStyles';
import GeneralIntegrations from './components/GeneralIntegrations';
import WorkspaceAndCalendar from './components/WorkspaceAndCalendar';
import { useIntegrationsLogic } from './hooks/useIntegrationsLogic';

interface IntegrationsProps {
  sx?: SxProps;
}

const Integrations = ({ sx }: IntegrationsProps) => {
  const {
    hasGoogle,
    hasMicrosoft,
    onDisconnect,
    connectToGoogle,
    connectToMicrosoft,
    connectToUnifiedProvider,
    isConnected,
    unifiedIntegrationsAuth
  } = useIntegrationsLogic();

  return (
    <Content sx={sx}>
      <WorkspaceAndCalendar
        hasGoogle={hasGoogle}
        hasMicrosoft={hasMicrosoft}
        onDisconnect={onDisconnect}
        connectToGoogle={connectToGoogle}
        connectToMicrosoft={connectToMicrosoft}
      />

      <GeneralIntegrations
        unifiedIntegrationsAuth={unifiedIntegrationsAuth}
        isConnected={isConnected}
        onDisconnect={onDisconnect}
        connectToUnifiedProvider={connectToUnifiedProvider}
      />
    </Content>
  );
};

export default Integrations;
